<div class="modal-header" ngxModalDraggable>
  <h4 class="modal-title">{{user?.DisplayName}}</h4>
  <help-button *transloco="let h" [key]="h('help.ime.common.users')"></help-button>
  <button type="button" class="btn-close" aria-label="Close" (click)="close(user?.Id)">
  </button>
</div>
<div class="modal-body">
  <mes-user-edit *ngIf="user" [user]="user" (userChanged)="onChanged($event)"></mes-user-edit>
</div>
<mes-web-edit-modal-buttons [entityId]="entityId"
                            [hasDeleteButton]="!!entityId && !isCurrentUserEditMode"
                            [isPristine]="isPristine$ | async"
                            (deleteClick)="delete()"
                            (saveClick)="save($event)"
                            (addClick)="add.emit(user)"
                            (cancelClick)="close(user?.Id)">
</mes-web-edit-modal-buttons>
